module.exports = __webpack_public_path__ + "068d846ab3972e54006dd9ac3cbb48ac.png";